import { Injectable } from '@angular/core';
import { ButtonService } from '../../button/button.service';
import { NavigationService } from '../../navigation/navigation.service';
import { ProgressService } from '../../progress/progress.service';
import { FormCoreModule } from '../form-core.module';

@Injectable({
  providedIn: FormCoreModule
})
export class AttachComponentsService {

  constructor(private bts: ButtonService, private progs: ProgressService, private navs: NavigationService) { }

  attach() {
    this.progs.create()
    this.navs.create()
    this.bts.create()
  }

  destroy() {
    this.bts.destroy()
    this.navs.destroy()
    this.progs.destroy()
  }
}
